import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { RequestResponse } from '../model/dto/RequestResponse';
import { Position } from '../model/Position';
import { PositionParamsDtos } from '../model/dto/PositionParamsDtos';

@Injectable()
export class PositionFacade {
    private _urlBase: string;
    private _httpClient: HttpClient;

    constructor(http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
        this._urlBase = baseUrl;
        this._httpClient = http;
    }

    GetPosition(): Observable<RequestResponse<[Position]>> {
        return this._httpClient.get<RequestResponse<[Position]>>(this._urlBase + 'api/Position');
    }

    PostPosition(request: PositionParamsDtos): Observable<RequestResponse<number>> {
        return this._httpClient.post<RequestResponse<number>>(this._urlBase + 'api/Position', request);
    }

    PutPosition(request: PositionParamsDtos, idPosition: number): Observable<RequestResponse<number>> {
        return this._httpClient.put<RequestResponse<number>>(this._urlBase + 'api/Position/' + idPosition, request);
    }

    DeletePosition(idPosition: number): Observable<RequestResponse<boolean>> {
        return this._httpClient.delete<RequestResponse<boolean>>(this._urlBase + 'api/Position/' + idPosition);
    }

    GetPositionByEmail(email: string): Observable<RequestResponse<Position>> {
        return this._httpClient.get<RequestResponse<Position>>(this._urlBase + 'api/Position/ByEmail/' + email);
    }

}
